import React, { Component } from 'react';
import { TextField } from '@material-ui/core';

/**
 * region for hepers*/
import typing from '../../../helpers/typing';


class NotificationsHeader extends Component {
    state = {
        header: "",
        error: false,
        validate: true
    };

    componentWillReceiveProps(nextProps) {
        this.setState({ header: nextProps.header, error: nextProps.error, validate: nextProps.validate });
    }

    onChange = (e) => {
        let error = false;
        if (typing.isEmpty(e.target.value) && this.state.validate) {
            error = true;
        }
        this.setState({ header: e.target.value, error: error });
    }

    onBlur = (e) => {
        this.props.onAttributeUpdateHtml({ header: this.state.header }, this.state.error, e.target.id)
    }

    render() {
        const { header, error } = this.state;
        return (
            <TextField
                label="Header"
                id="header"
                style={{ marginTop: 8, marginBottom: 8 }}
                placeholder=""
                fullWidth
                multiline
                rows={5}
                rowsMax={10}
                margin="normal"
                variant="outlined"
                error={error}
                value={header}
                onBlur={this.onBlur}
                onChange={this.onChange}
                InputLabelProps={{
                    shrink: true,
                }}
            />
        )
    }
};
export default NotificationsHeader;